import { render, staticRenderFns } from "./PollMenu.vue?vue&type=template&id=578e53a4&scoped=true&"
import script from "./PollMenu.vue?vue&type=script&lang=ts&"
export * from "./PollMenu.vue?vue&type=script&lang=ts&"
import style0 from "./PollMenu.vue?vue&type=style&index=0&id=578e53a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578e53a4",
  null
  
)

export default component.exports